import { Component } from "react";
import {recoverFromChunkError} from "../utils/pageLoadResilience.mjs";
import { Container, Row, Col, Card, Button } from "react-bootstrap";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    recoverFromChunkError(error);
    console.error("Unhandled error rendering SmartMenu UI", error, info);
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
    this.props.onReset?.();
  };

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <Container className="py-5">
        <Row className="justify-content-center">
          <Col md={8} lg={6}>
            <Card className="shadow-sm">
              <Card.Body className="text-center">
                <h1 className="h4 fw-bold mb-3">Something went wrong</h1>
                <p className="text-muted mb-4">
                  Please try again. If the issue persists, capture the console error details and share them with support.
                </p>
                <div className="small text-muted border rounded p-3 mb-4 text-break">
                  {this.state.error?.message || "Unknown error"}
                </div>
                <Button variant="primary" onClick={this.handleRetry}>
                  Retry
                </Button>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default ErrorBoundary;
